import { PiBrain } from 'react-icons/pi';
import { FiCheckCircle, FiClipboard, FiCoffee, FiEdit, FiEdit3, FiHome, FiMap, FiMessageSquare, FiMonitor, FiVideo } from 'react-icons/fi';
import { VscGame } from 'react-icons/vsc';
import { BsFileEarmarkCheck } from 'react-icons/bs';
import brain from './img/brain.svg';
import monitor from './img/monitor.svg';
import check from './img/check.svg';
import activity from './img/activity.svg';
import message from './img/message.svg';
import IconPerformance from '@/components/custom/icons/IconPerformance';
import IconExams from '@/components/custom/icons/IconExams';
import IconSimulated from '@/components/custom/icons/IconSimulated';
import IconExercises from '@/components/custom/icons/IconExercises';
import DuelIcon from '@/components/custom/icons/DuelIcon';

export function studentMenu({ session, abilities, checkPermission }) {
  const appName = process.env.REACT_APP_NAME;

  return [
    {
      id: 1,
      route: '/',
      icon: <FiHome />,
      label: 'Home'
    },
    {
      id: 2,
      icon: <PiBrain />,
      submenu: {
        img: brain,
        title: 'Aprendizado Dinâmico',
        subtitle: 'Aprendizagem guiada pela T.I.A. - nossa Tecnologia de Inteligência Artificial',
        nav: [
          {
            route: '/trilha',
            icon: <FiMap />,
            title: 'Trilha',
            description: 'Sua trilha de aprendizagem guiada',
            visible: abilities?.['plano-de-estudo']
          },
          {
            route: '/desafio-da-semana',
            icon: <VscGame strokeWidth={0.6} />,
            title: 'Desafio da semana',
            description: 'Vença disputas de conhecimento e acumule pontos',
            visible: abilities?.['desafio-da-semana']
          },
          {
            route: '/duelos',
            icon: <DuelIcon />,
            title: 'Duelos',
            description: 'Participe de duelos e teste seus conhecimentos',
            visible: abilities?.duelos
          },
          {
            route: `/usuario/metricas/${session?.user?.id}`,
            icon: <IconPerformance />,
            title: 'Desempenho',
            description: 'Acompanhe sua performance',
            visible: abilities?.desempenho
          }
        ]
      }
    },
    {
      id: 3,
      icon: <FiMonitor />,
      submenu: {
        img: monitor,
        title: 'Cursos e Aulas',
        subtitle: 'Uma biblioteca completa de recursos educacionais',
        nav: [
          {
            route: '/curso',
            icon: <FiMonitor />,
            title: 'Cursos',
            description: 'Assista a aulas e acesse materiais complementares',
            visible: checkPermission(session, 'Visualizar lista de módulos e seus conteúdos', 'Cursos') && abilities?.cursos
          },
          {
            route: '/aulas-ao-vivo',
            icon: <FiVideo />,
            title: 'Aulas ao vivo',
            description: 'Participe de sessões interativas em tempo real',
            visible: abilities?.['aulas-ao-vivo'] && checkPermission(session, 'Visualizar aulas ao vivo', 'Aulas ao vivo')
          },
          {
            route: '/grade-horaria',
            icon: <FiMap />,
            title: 'Horários',
            description: 'Visualize horários das aulas ao vivo',
            visible: appName === 'canaleducacao'
          }
        ]
      }
    },
    {
      id: 4,
      icon: <FiCheckCircle />,
      submenu: {
        img: check,
        title: 'Avaliações e Questões',
        subtitle: 'Coloque à prova o seu conhecimento',
        nav: [
          {
            route: '/avaliacoes',
            icon: <IconExams />,
            title: 'Provas',
            description: 'Teste seu conhecimento',
            visible: abilities?.['avaliacoes-simulados'] || abilities?.['avaliacoes-provas']
          },
          {
            route: '/simulados',
            icon: <IconSimulated />,
            title: 'Simulados',
            description: 'Simule exames reais',
            visible: abilities?.['avaliacoes-simulados'] || abilities?.['avaliacoes-provas']
          },
          {
            route: '/questions/apostilas',
            icon: <IconExercises />,
            title: 'Exercícios',
            description: 'Responda perguntas e listas de exercícios',
            visible: abilities?.['avaliacoes-apostilas']
          }
        ]
      }
    },
    {
      id: 5,
      icon: <FiEdit3 />,
      submenu: {
        img: activity,
        title: 'Atividades',
        subtitle: 'Realize tarefas e acesse materiais extras',
        nav: [
          {
            route: '/atividade-complementar',
            icon: <BsFileEarmarkCheck />,
            title: 'Atividade Complementar',
            description: 'Atividade de estudo individual',
            visible: checkPermission(session, 'Visualizar lista de atividades', 'Arquivos e atividades complementares') && abilities?.['cursos-ativ-complementar'] && appName !== 'floriano-educa-7'
          },
          {
            route: '/redacao',
            icon: <FiEdit />,
            title: 'Redação',
            description: 'Desenvolva suas habilidades de escrita',
            visible: abilities?.redacao && appName !== 'floriano-educa-7'
          },
          {
            route: '/projetos',
            icon: <FiClipboard />,
            title: 'Projetos',
            description: 'Realize trabalhos colaborativos e receba avaliações',
            visible: checkPermission(session, 'Visualizar lista de projetos', 'Projetos') && abilities?.projetos && appName !== 'floriano-educa-7'
          }
        ]
      }
    },
    {
      id: 6,
      icon: <FiMessageSquare />,
      submenu: {
        img: message,
        title: 'Comunidade',
        subtitle: 'Aqui todos se reúnem para partilhar e aprender',
        nav: [
          {
            route: '/auditorio',
            icon: <FiMessageSquare />,
            title: 'Monitoria',
            description: 'Tire dúvidas em tempo real',
            visible: abilities?.auditorio && checkPermission(session, 'Visualizar monitorias', 'Monitorias')
          },
          {
            route: '/feed',
            icon: <FiCoffee />,
            title: 'Fórum',
            description: 'Troque experiências com outros alunos e professores',
            visible: checkPermission(session, 'Visualizar postagens e comentários', 'Fórum') && abilities?.feed
          }
        ]
      }
    }
  ];
}
